module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo03-c0955a2fdbb93ff71c925d57bfda00d7.jpg";